// 默认组件数据配置
const defaultData = {
  // 文本组件默认数据
  text: {
    data: [
      {
        type: "title",
        title: "这里是文本标题",
        color: "",
        fontSize: 20,
        titleFontSize: 20,
        fontWeight: "bold",
        textAlign: "left",
      },
      {
        type: "paragraph",
        content: "这里是文本内容这里是文本内容这里是文本内容这里是文本内容",
        color: "#333333",
        contentColor: "#986523",
        fontSize: 14,
        fontWeight: "normal",
        textAlign: "left",
      },
    ],
  },

  tableHeaders: {
    // 活动管理-用户表格列配置
    userTable: [
      { title: "用户编号", prop: "userId", minWidth: "100", align: "center" },
      {
        title: "用户名称",
        prop: "userName",
        minWidth: "100",
        align: "center",
      },
      { title: "联系电话", prop: "phone", minWidth: "100", align: "center" },
      {
        title: "创建时间",
        prop: "createTime",
        minWidth: "120",
        align: "center",
      },
      {
        title: "操作",
        prop: "operate",
        minWidth: "100",
        align: "center",
        sortable: true,
        scopedSlots: { customRender: "action" },
      },
    ],
    // 文章列表表格列配置
    articleTable: [
      {
        title: "文章编号",
        prop: "articleId",
        minWidth: "80",
        align: "center",
        fixed: "left",
      },
      {
        title: "文章名称",
        prop: "articleName",
        minWidth: "100",
        align: "center",
        fixed: false,
        sortable: true,
      },
      {
        title: "类型",
        prop: "categoryName",
        minWidth: "100",
        align: "center",
        fixed: false,
        sortable: true,
      },
      {
        title: "阅读量",
        prop: "readCount",
        minWidth: "100",
        align: "center",
        fixed: false,
        sortable: true,
      },
      {
        title: "转发量",
        prop: "forwardCount",
        minWidth: "100",
        align: "center",
        fixed: false,
        sortable: true,
      },
      {
        title: "收藏数",
        prop: "collectCount",
        minWidth: "100",
        align: "center",
        fixed: false,
        sortable: true,
      },
      {
        title: "留言数",
        prop: "messageCount",
        minWidth: "100",
        align: "center",
        fixed: false,
        sortable: true,
      },
      {
        title: "发布人",
        prop: "publishUser",
        minWidth: "100",
        align: "center",
        fixed: false,
      },
      {
        title: "发布时间",
        prop: "publishTime",
        minWidth: "120",
        align: "center",
        fixed: false,
      },
      {
        title: "状态",
        prop: "status",
        minWidth: "120",
        align: "center",
        fixed: false,
        scopedSlots: { customRender: "status" },
      },
      {
        title: "操作",
        prop: "operate",
        minWidth: "150",
        align: "center",
        sortable: true,
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ],
    // 轮播图列表表格列配置
    carouselTable: [
      { title: "业务名称", prop: "name", minWidth: "130", align: "center" },
      {
        title: "类型",
        prop: "type",
        minWidth: "100",
        align: "center",
        sortable: true,
      },
      {
        title: "图片",
        prop: "image",
        // width: "160",
        // 将固定宽度改为最小宽度，让列可以自适应
        minWidth: "100",
        align: "center",
        sortable: true,
        scopedSlots: { customRender: "image" }, //当前列自定义渲染
      },
      {
        title: "上传时间",
        prop: "uploadTime",
        width: "160",
        align: "center",
        sortable: true,
      },
      {
        title: "上传人",
        prop: "uploadUser",
        minWidth: "100",
        align: "center",
      },
      {
        title: "状态",
        prop: "status",
        minWidth: "50",
        align: "center",
        scopedSlots: { customRender: "status" }, //当前列自定义渲染
      },
      {
        title: "操作",
        prop: "operate",
        minWidth: "200",
        align: "center",
        sortable: true,
        scopedSlots: { customRender: "action" },
      },
    ],
    // 公众号管理-用户表格列配置
    userManagerHeaders: [
      {
        title: "用户昵称",
        prop: "nickname",
        minWidth: "100",
        align: "center",
        fixed: "left",
      },
      {
        title: "用户头像",
        prop: "avatar",
        minWidth: "80",
        align: "center",
        scopedSlots: { customRender: "avatar" },
      },
      {
        title: "微信号",
        prop: "wechat",
        minWidth: "80",
        align: "center",
      },
      {
        title: "关注时间",
        prop: "followTime",
        minWidth: "140",
        align: "center",
      },
      {
        title: "是否订阅",
        prop: "isSubscribed",
        minWidth: "80",
        align: "center",
        scopedSlots: { customRender: "isSubscribed" },
      },
      {
        title: "关注来源",
        prop: "followSource",
        minWidth: "130",
        align: "center",
        scopedSlots: { customRender: "followSource" },
      },
      {
        title: "最近互动时间",
        prop: "lastInteractionTime",
        minWidth: "150",
        align: "center",
      },
      { title: "手机号", prop: "phone", minWidth: "120", align: "center" },
      {
        title: "标签",
        prop: "tags",
        minWidth: "100",
        align: "center",
        scopedSlots: { customRender: "tags" },
      },
      // {
      //   title: "创建时间",
      //   prop: "createTime",
      //   minWidth: "150",
      //   align: "center",
      // },
      {
        title: "操作",
        prop: "operate",
        minWidth: "200",
        align: "center",
        sortable: true,
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ],
    // 公众号管理-自动回复表格列配置
    autoReplyTable: [
      {
        title: "规则名称",
        prop: "ruleName",
        minWidth: "100",
        align: "center",
      },
      {
        title: "关键词",
        prop: "keyword",
        minWidth: "100",
        align: "center",
      },
      {
        title: "回复内容",
        prop: "replyContent",
        minWidth: "100",
        align: "center",
      },
      {
        title: "状态",
        prop: "status",
        minWidth: "100",
        align: "center",
        scopedSlots: { customRender: "status" },
      },
      {
        title: "操作",
        prop: "operate",
        minWidth: "100",
        align: "center",
        sortable: true,
        scopedSlots: { customRender: "action" },
      },
    ],
    // 公众号管理-用户留言表格列配置
    userMessageTable: [
      {
        title: "规则名称",
        prop: "ruleName",
        minWidth: "100",
        align: "center",
        scopedSlots: { customRender: "ruleName" },
      },
      {
        title: "操作",
        prop: "operate",
        minWidth: "100",
        align: "center",
        sortable: true,
        scopedSlots: { customRender: "action" },
      },
    ],
  },

  // 发布弹窗表格列配置
  dialogTableHeaders: {
    headers: [
      {
        title: "文章编号",
        prop: "articleId",
        minWidth: "130",
        align: "center",
      },
      {
        title: "文章名称",
        prop: "articleName",
        minWidth: "100",
        align: "center",
        sortable: false,
      },
      {
        title: "顺序",
        prop: "readCount",
        minWidth: "100",
        align: "center",
        sortable: false,
      },
      {
        title: "操作",
        prop: "forwardCount",
        minWidth: "100",
        align: "center",
        sortable: false,
      },
    ],
  },
  // 相关按钮配置数组
  actionButtons: {
    topArticleButtons: [
      {
        id: "add",
        text: "新增",
        icon: "el-icon-plus",
        type: "primary",
        isIcon: true,
        isShow: false,
        isPlain: true,
        size: "small",
        handler: "handleAddClick",
        customStyle: {
          backgroundColor: "#E8F4FF",
          borderRadius: "5px",
          cursor: "pointer",
          color: "#508EF2",
          border: "2px solid #508EF2",
        },
      },
      {
        id: "release",
        text: "发布",
        icon: "el-icon-edit",
        type: "primary",
        isIcon: true,
        isShow: false,
        isPlain: true,
        size: "small",
        handler: "handleReleaseClick",
        customStyle: {
          backgroundColor: "#FFF0E9",
          borderRadius: "5px",
          cursor: "pointer",
          color: "#FF7225",
          border: "2px solid #FF7225",
        },
      },
      {
        id: "edit",
        text: "修改",
        icon: "el-icon-edit",
        type: "primary",
        isIcon: true,
        isShow: false,
        isPlain: true,
        size: "small",
        handler: "handleEditClick",
        customStyle: {
          backgroundColor: "#E6F7F1",
          borderRadius: "5px",
          cursor: "pointer",
          color: "#43C393",
          border: "2px solid #43C393",
        },
      },
      {
        id: "delete",
        text: "删除",
        icon: "el-icon-delete",
        type: "danger",
        isIcon: true,
        isShow: false,
        isPlain: true,
        size: "small",
        handler: "handleDeleteClick",
        customStyle: {
          backgroundColor: "#FEEEEE",
          borderRadius: "5px",
          cursor: "pointer",
          color: "#F88484",
          border: "2px solid #F88484",
        },
      },
      {
        id: "cancel",
        text: "取消",
        icon: "",
        type: "danger",
        isIcon: false,
        isShow: false,
        isPlain: false,
        size: "small",
        handler: "handleCancelClick",
        customStyle: {
          backgroundColor: "#FFF",
          borderRadius: "5px",
          paddingLeft: "50px",
          paddingRight: "50px",
          color: "var(--primary)",
          border: "1px solid var(--primary)",
        },
      },
      {
        id: "confirm",
        text: "确认",
        icon: "",
        type: "primary",
        isIcon: false,
        isShow: false,
        isPlain: false,
        size: "small",
        handler: "handleConfirmClick",
        customStyle: {
          backgroundColor: "var(--primary)",
          borderRadius: "5px",
          paddingLeft: "50px",
          paddingRight: "50px",
          color: "#FFF",
        },
      },
    ],
    tableArticleButtons: [
      {
        id: "online",
        text: "上架",
        handler: "handleOnlineClick",
      },
      {
        id: "detail",
        text: "详情",
        handler: "handleDetailClick",
        style: {},
      },
      {
        id: "editRow",
        text: "编辑",
        handler: "handleRowEditClick",
      },
      {
        id: "deleteRow",
        text: "删除",
        handler: "handleRowDeleteClick",
        style: { marginLeft: "10px" },
      },
    ],
    tableCarouselButtons: [
      {
        id: "editRow",
        text: "编辑",
        handler: "handleRowEditClick",
      },
      {
        id: "deleteRow",
        text: "删除",
        handler: "handleRowDeleteClick",
        style: { marginLeft: "10px" },
      },
    ],
    moduleButtons: [
      {
        id: "CustomTransfer", //对应ref节点里对应的方法名称
        ref: "rightPanel", //方便获取对应ref节点里的对应方法
        outline: false, //按钮是否镂空
        text: "新建文章",
        icon: "",
        handler: "handleClick",
        customStyle: {},
        type: "isChildrenRightPanel",
      },
      {
        id: "triggerFloat", //对应ref节点里对应的方法名称
        ref: "rightPanel", //方便获取对应ref节点里的对应方法
        outline: true, //按钮是否镂空
        text: "选择文章",
        icon: "",
        handler: "handleClick",
        customStyle: {},
        type: "isChildrenRightPanel",
      },
      {
        id: "addModule", //对应ref节点里对应的方法名称
        type: "addModule", //按钮标识
        ref: "sliderassembly", //方便获取对应ref节点里的对应方法
        outline: true, //按钮是否镂空
        text: "添加模块",
        icon: "",
        handler: "handleClick",
        customStyle: {},
      },
    ],
  },
  //企业官网页面设计模块的左侧导航栏静态数据
  sidebarNavData: {
    menuItems: [
      {
        index: "1",
        componentName: "home",
        meta: {
          title: "首页",
          icon: "icon-shouye",
        },
      },
      {
        index: "2",
        componentName: "templateIndex",
        meta: {
          title: "模板",
          icon: "icon-a-moban2",
        },
      },
      {
        index: "3",
        componentName: "moduleIndexMobile",
        meta: {
          title: "模块",
          icon: "icon-mokuaiyingyong",
        },
      },
      {
        index: "4",
        componentName: "carouselIndex",
        meta: {
          title: "轮播",
          icon: "icon-lunbo-03",
        },
      },
      {
        index: "5",
        componentName: "articleIndex",
        meta: {
          title: "推文",
          icon: "icon-fabudankuang-tuiwen",
        },
        children: [
          {
            index: "5-1",
            componentName: "articleTemplateIndex",
            meta: {
              title: "新建文章",
              icon: "",
            },
          },
          {
            index: "5-2",
            componentName: "articleListIndex",
            meta: {
              title: "文章列表",
              icon: "",
            },
          },
          {
            index: "5-3",
            componentName: "activeManageIndex",
            meta: {
              title: "活动管理",
              icon: "",
            },
          },
        ],
      },
      {
        index: "6",
        componentName: "aiIndex",
        meta: {
          title: "AI",
          icon: "icon-ait",
        },
      },
      {
        index: "7",
        meta: {
          title: "公众号管理",
          icon: "icon-gongzhonghaoguanli",
        },
        children: [
          {
            index: "7-1",
            componentName: "wechatBasicInfoIndex",
            meta: {
              title: "基本信息",
              icon: "",
            },
          },
          {
            index: "7-2",
            componentName: "wechatUserInfoIndex",
            meta: {
              title: "用户管理",
              icon: "",
            },
          },
          {
            index: "7-3",
            componentName: "wechatAutoReplyIndex",
            meta: {
              title: "自动回复",
              icon: "",
            },
          },
          {
            index: "7-4",
            componentName: "wechatUserMessageIndex",
            meta: {
              title: "用户留言",
              icon: "",
            },
          },
          {
            index: "7-5",
            componentName: "wechatPrivateMessageIndex",
            meta: {
              title: "私信",
              icon: "",
            },
          },
        ],
      },
      {
        index: "8",
        meta: {
          title: "商城管理",
          icon: "icon-shangchengguanli",
        },
        children: [
          {
            index: "8-1",
            componentName: "productListIndex",
            meta: {
              title: "商品列表",
              icon: "",
            },
          },
          {
            index: "8-2",
            componentName: "customerInfoIndex",
            meta: {
              title: "客户信息",
              icon: "",
            },
          },
        ],
      },
    ],
  },
  //选中的颜色
  // 颜色选择器预设
  predefineColors: {
    predefineColors: [
      "#ff4500",
      "#ff8c00",
      "#ffd700",
      "#90ee90",
      "#00ced1",
      "#1e90ff",
      "#c71585",
      "#409EFF",
      "#909399",
      "#C0C4CC",
      "rgba(255, 69, 0, 0.68)",
      "rgb(255, 120, 0)",
      "hsv(51, 100, 98)",
      "hsva(120, 40, 94, 0.5)",
      "hsl(181, 100%, 37%)",
      "hsla(209, 100%, 56%, 0.73)",
      "#c7158577",
    ],
  },
  // 字号
  wordSizeOptions: {
    wordSizeOptions: [
      {
        label: "12px",
        value: 12,
      },
      {
        label: "14px",
        value: 14,
      },
      {
        label: "16px",
        value: 16,
      },
      {
        label: "18px",
        value: 18,
      },
      {
        label: "20px",
        value: 20,
      },
    ],
  },
  // 字体
  fontFamilyOptions: {
    fontFamilyOptions: [
      { label: "微软雅黑", value: "Microsoft YaHei" },
      { label: "宋体", value: "SimSun" },
      { label: "黑体", value: "SimHei" },
      { label: "苹方", value: "PingFang SC" },
      { label: "幼圆", value: "YouYuan" },
    ],
  },
  // 搜索内容
  searchOptions: {
    searchOptions: [
      { label: "商品名称", value: "productName" },
      { label: "商品分类", value: "productCategory" },
      { label: "商品标签", value: "productTag" },
    ],
  },

  // 相关表单配置项
  form: {
    // 表单配置项（按需配置不同类型的控件）
    articleFormItems: [
      // 下拉框
      {
        label: "推文属于哪个tap",
        prop: "username",
        type: "select",
        required: true,
        options: [
          { label: "技术部", value: "tech" },
          { label: "人事部", value: "hr" },
          { label: "财务部", value: "finance" },
        ],
      },
      // 上传组件
      {
        label: "封面",
        prop: "uploadList",
        type: "upload",
        action: "/api/upload", // 替换为你的真实上传接口
        accept: "image/*",
        limit: 1,
        tip: "仅支持jpg/png格式，大小不超过2MB",
      },
      // 输入框
      {
        label: "摘要",
        prop: "remark",
        type: "input",
        inputType: "textarea",
        required: false,
        placeholder: "请输入摘要",
      },

      // 单选框
      {
        label: "发布至",
        prop: "releaseTo",
        type: "radio",
        required: true,
        options: [
          { label: "发布推文", value: 1 },
          { label: "发布至推文且同步至公众号", value: 2 },
        ],
      },
      {
        label: "留言",
        prop: "leaveMessage",
        type: "switch", // 核心：指定类型为 switch
        required: false,
        disabled: false,
        activeText: "", // 开启时的文本
        inactiveText: "", // 关闭时的文本
        activeValue: 1, // 开启时的值（可自定义，默认 true）
        inactiveValue: 0, // 关闭时的值（可自定义，默认 false）
        activeColor: "var(--primary)", // 开启时的背景色
        inactiveColor: "var(--gray)", // 关闭时的背景色
      },
      {
        label: "通知",
        prop: "notice",
        type: "switch", // 核心：指定类型为 switch
        required: false,
        disabled: false,
        activeText: "", // 开启时的文本
        inactiveText: "", // 关闭时的文本
        activeValue: 1, // 开启时的值（可自定义，默认 true）
        inactiveValue: 0, // 关闭时的值（可自定义，默认 false）
        activeColor: "var(--primary)", // 开启时的背景色
        inactiveColor: "var(--gray)", // 关闭时的背景色
      },
      // 多选框
      // {
      //   label: "兴趣爱好",
      //   prop: "hobby",
      //   type: "checkbox",
      //   options: [
      //     { label: "阅读", value: "read" },
      //     { label: "运动", value: "sport" },
      //     { label: "音乐", value: "music" },
      //   ],
      // },
    ],
  },
};
//
export const textDefaultData = defaultData.text.data;
// 表格列配置
export const tableHeaders = defaultData.tableHeaders;

export const dialogTableHeaders = defaultData.dialogTableHeaders.headers;
export const actionButtons = defaultData.actionButtons;
export const sidebarNavData = defaultData.sidebarNavData;
export const predefineColors = defaultData.predefineColors.predefineColors;
export const wordSizeOptions = defaultData.wordSizeOptions.wordSizeOptions;
export const fontFamilyOptions =
  defaultData.fontFamilyOptions.fontFamilyOptions;
export const searchOptions = defaultData.searchOptions.searchOptions;
export const formItems = defaultData.form;
export const userTableHeaders = defaultData.userTable;
